import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import Swal from "helpers/swal";
import Table from "components/Table";
import Button from "components/Button";
import { CUSTOM_SETTINGS } from "constants/index";
import { getSelectedData } from "helpers/common";
import FieldChooser from "components/FieldChooser";

import { columns } from "./columns";
import { connect } from "../../reduxConnector";
import AreaStatementSearch from "../areaStatementView/partials/areaStatementSearch";
import areaStatementCreateActions from "./actions";
import _ from "lodash";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { IMeta, IMyDelivery, IOrderRelation } from "models/index";
import { History } from "history";

interface IProps {
  getAreaStatements: (meta?: IMeta) => void;
  initCreateSpring: (object?: any, redirect?: boolean) => void;
  meta: IMeta;
  history: History;
  roles: string[];
  intl: any;
  roleIds: any[];
  areaStatements: any[];
  orders: IOrderRelation[];
  getSelectOptions: () => void;
  statusOptions: any[];
  typeOptions: any[];
  getExportData: () => void;
}

class AreaStatementCreate extends React.Component<IProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: [],
      selectedAreaStatement: {},
    };
  }

  public handleSelect = (selectedOption) => {
    const { selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _.map(selectedData, "orderId");

    value === "gelezen" && markAsRead(ids);
    value === "ongelezen" && markAsUnread(ids);
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "AREA STATEMENT");
      markAsRead(ids);
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser,
    }));
  };

  public handleFieldsChange = (data) => {
    this.setState({ columnsCopy: data });
  };

  public onRowClick = (rowData) => {
    console.log("Row clicked");
  };

  private onRowSelect = (checkedRows) => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.areaStatements,
        checkedRows,
        this.state.selectedData,
        "orderId"
      ),
    });
  };

  private checkStatementType = async () => {
    const { checkedRows, selectedData } = this.state;
    const {
      intl: { formatMessage },
      initCreateSpring,
      areaStatements,
    } = this.props;

    if (_.isEmpty(checkedRows)) {
      Swal.alert("Info", formatMessage({ id: "DELIVERIES_MINIMUM_ONE_ORDER" }));
    } else {
      if (Object.keys(checkedRows).length > 1) {
        Swal.alert(
          "warning",
          formatMessage({ id: "AREA_STATEMENT_MORE_THAN_ONE_ERROR" })
        );
        return;
      }
      // !! remember to add data type for this
      const areaStatement = areaStatements.find(
        (areaStatement) => areaStatement.Id === selectedData[0].id
      );
      this.setState({
        selectedAreaStatement: areaStatement,
      });
      initCreateSpring(areaStatement);
    }
  };

  private extractMinAndMaxYears = (areaStatements) => {
    const years = areaStatements.map((areaStatement) => {
      return areaStatement.AreaStatement.HarvestYear;
    });
    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);
    return { minYear, maxYear };
  };

  public render() {
    const {
      areaStatements,
      getAreaStatements,
      meta,
      roleIds,
      statusOptions,
      typeOptions,
    } = this.props;
    const { showFieldChooser, columnsCopy, checkedRows } = this.state;

    const yearRange = this.extractMinAndMaxYears(areaStatements);

    return (
      <div id="my-deliveries-pagee">
        <div className="child-header">
          <FormattedMessage id="AREA_STATEMENT_TITLE" tagName="h1" />
          <Button
            id="create-delivery-top"
            kind="primary"
            className="animate-bg bg-white"
            onClick={this.checkStatementType}
          >
            AREA_STATEMENT_MAKE
          </Button>
        </div>
        <div className="delivery-search">
          <AreaStatementSearch
            meta={meta}
            onSearch={getAreaStatements}
            roleIds={roleIds}
            typeOptions={typeOptions}
            statusOptions={statusOptions}
            yearRange={yearRange}
          />
        </div>
        <Table
          columns={columnsCopy}
          dataSource={areaStatements}
          onRowClick={this.onRowClick}
          meta={meta}
          onQueryChange={getAreaStatements}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          groupBy="groupingType"
          pageName={CUSTOM_SETTINGS.areaStatements}
        />
        <FieldChooser
          name="areaalopgaven"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    areaStatements: state.areaStatements.items,
    meta: state.areaStatements.meta,
    roleIds: state.app.roleIds,
    statusOptions: state.areaStatements.statusOptions,
    typeOptions: state.areaStatements.typeOptions,
  }),
  {
    getAreaStatements: areaStatementCreateActions.getAreaStatementsList,
    initCreateSpring: areaStatementCreateActions.initCreateSpring,
  }
)(injectIntl(AreaStatementCreate));
